/**
 *
 * Checks to make sure the window object and the piwik queue are available before logging events.
 *
 * ```js
 * import { method } from '@minerva-analytics/pantheon';
 *
 * method(`trackPageView`, []);
 * method(`trackEvent`, ['click', 'button', 'view-more-button', 1]);
 * ```
 *
 * @param {string} type - type of piwik method
 * @param {Array} data - data for the given piwik method
 */

/* eslint-disable */
var piwikMethod = function piwikMethod(type, data) {
  if (window && window._paq) {
    window._paq.push([type].concat(data));
  }
};
/* eslint-enable */


export default piwikMethod;